import React, {Component} from 'react'
import axios from 'axios'
import Header from '../Header'
import 'react-select/dist/react-select.css'
import * as GymHelpers from '../../helpers/gymHelpers'
import UserOrLogin from '../UserOrLogin'
import DisplayWall from './DisplayWallEdit'
import Loading from '../Loading'
import LaddaButton, {SLIDE_UP} from '../LaddaButton'
import * as UrlHelpers from '../../helpers/urlHelpers'
import {Redirect} from 'react-router-dom'

class EditWall extends Component {
  constructor(props) {
    super(props)
    let gymId = this.props.match.params.gymName
    let wallId = this.props.match.params.wallName
    this.state = {
      holds: [],
      problems: [],
      scale: 1.0,
      isAddingHold: false,
      gymId: gymId,
      wallId: wallId,
      newProblemGrade: GymHelpers.grades[0],
      loading: true,
    }
    this.onResize = this.onResize.bind(this)
    this.handleHoldClick = this.handleHoldClick.bind(this)
    this.getGym = this.getGym.bind(this)
    this.getWallAndHolds = this.getWallAndHolds.bind(this)
    this.setImageRef = this.setImageRef.bind(this)
  }

  getGym() {
    return GymHelpers.getGym(this.state.gymId).then(data => {
      this.setState({
        gym: data,
        walls: data.walls || {},
        wall: data.walls[this.state.wallId],
      })
    })
  }

  getWallAndHolds() {
    let holds = []
    let storageRef = window.firebaseStorage.ref()
    let wallId = this.state.wallId
    let wallDir = UrlHelpers.getWallDir(this.state.gym.key, wallId)
    let wallHoldsRef = storageRef.child(wallDir + '/holds.json')

    wallHoldsRef
      .getDownloadURL()
      .then(function (url) {
        return axios.get(url)
      })
      .catch(e => {
        console.info('Error fetching holds file: ')
        console.info(e)
      })
      .then(response => {
        if (response && response.data && response.data.annotation) {
          holds = response.data.annotation.object.map(hold => {
            return {
              xmax: Number(hold.bndbox.xmax),
              ymax: Number(hold.bndbox.ymax),
              xmin: Number(hold.bndbox.xmin),
              ymin: Number(hold.bndbox.ymin),
              selected: false,
            }
          })
          holds = GymHelpers.sortHolds(holds)
        } else {
          holds = []
        }
      })
      .then(() => {
        var img = new Image()
        img.src = this.state.wall.wallUrl
        let _this = this
        let clientWidth =
          (this.imageRef && this.imageRef.width) ||
          (this.containerRef && this.containerRef.width) ||
          window.innerWidth
        let clientHeight =
          (this.imageRef && this.imageRef.height) ||
          (this.containerRef && this.containerRef.height) ||
          window.innerHeight
        img.onload = function (e) {
          _this.setState(
            {
              imageWidth: this.width,
              imageHeight: this.height,
              img: img,
              holds: holds,
              clientWidth: clientWidth,
              clientHeight: clientHeight,
              scale: clientWidth / this.width,
              loading: false,
            },
            () => {
              _this.onResize()
            },
          )
        }
      })
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize, false)
    this.getGym().then(() => {
      this.getWallAndHolds()
    })
  }

  componentWillReceiveProps(nextProps) {
    let gymId = nextProps.match.params.gymName
    let wallId = nextProps.match.params.wallName
    this.setState(
      {
        holds: [],
        problems: [],
        scale: 1.0,
        gymId: gymId,
        wallId: wallId,
        activeHold: undefined,
      },
      () => {
        this.getGym().then(() => {
          this.getWallAndHolds()
        })
      },
    )
  }

  onResize() {
    let canvasWidth = window.innerWidth
    let canvasHeight = 0.8 * window.innerHeight
    let wScale = canvasWidth / this.state.imageWidth
    let hScale = canvasHeight / this.state.imageHeight
    let scale = wScale < hScale ? wScale : hScale
    let clientHeight = this.state.imageHeight * scale
    let clientWidth = this.state.imageWidth * scale
    this.setState({
      clientWidth: clientWidth,
      clientHeight: clientHeight,
      scale: scale,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  handleHoldClick(hold, index) {
    if (this.state.isAddingHold) {
      return
    }
    let newHold = Object.assign({}, hold)
    newHold.selected = true
    newHold.index = index
    this.setState({
      isAddingHold: true,
      newHold: newHold,
    })
  }

  setImageRef(imageRef) {
    let resize = this.resize
    this.imageRef = imageRef
    window.ir = this.imageRef
    if (resize) {
      this.resize = false
      this.onResize()
    }
  }

  handleAddHoldClick = (event, options = {}) => {
    let newHold = {}
    let scale = this.state.scale
    newHold.selected = true
    newHold.xmin = 100
    newHold.xmax = 200
    newHold.ymin = 100
    newHold.ymax = 200
    console.info(event.center)
    if (event.type === 'press') {
      let rect = this.imageRef.parentNode.getBoundingClientRect()
      console.info(rect)
      let rect2 = this.imageRef.getBoundingClientRect()
      console.info(rect2)
      newHold.xmin = (event.center.x - 0 * rect.x) / scale - 50
      newHold.xmax = (event.center.x - 0 * rect.x) / scale + 50
      newHold.ymin = (event.center.y - 0 * rect.y) / scale - 50 // this accounts for the top header
      newHold.ymax = (event.center.y - 0 * rect.y) / scale + 50 // this accounts for the top header
    }
    this.setState({
      isAddingHold: true,
      newHold: newHold,
    })
  }
  handleCancelAddHoldClick = () => {
    this.setState({
      isAddingHold: false,
      newHold: undefined,
    })
  }
  handleRemoveHoldClick = () => {}

  updateNewHold = (gesture, options = {}) => {
    let newHold = Object.assign({}, this.state.newHold)
    let scale = this.state.scale
    let {xmin, xmax, ymin, ymax} = this.state.newHold
    let halfWidth = (xmax - xmin) / 2.0
    let halfHeight = (ymax - ymin) / 2.0
    let xcenter = halfWidth + xmin
    let ycenter = halfHeight + ymin
    if (
      (gesture.type === 'pan' || gesture.type === 'panend') &&
      options.resizingHold
    ) {
      let deltaX = gesture.deltaX / scale
      let deltaY = gesture.deltaY / scale
      newHold.xmin -= deltaX / 2.0
      newHold.xmax += deltaX / 2.0
      newHold.ymin += deltaY / 2.0
      newHold.ymax -= deltaY / 2.0
      this.setState({
        newHold: newHold,
      })
    } else if (gesture.type === 'pan' || gesture.type === 'panend') {
      let deltaX = gesture.deltaX / scale
      let deltaY = gesture.deltaY / scale
      newHold.xmin += deltaX
      newHold.xmax += deltaX
      newHold.ymin += deltaY
      newHold.ymax += deltaY
      this.setState({
        newHold: newHold,
      })
    } else if (gesture.type === 'pinch') {
      if (gesture.additionalEvent === 'pinchout') {
        let newHalfWidth = halfWidth * 1.01
        let newHalfHeight = halfHeight * 1.01
        let absRotation = Math.abs(gesture.rotation)
        //we will only set either the horizontal or vertical component based on the angle of pinch
        if (absRotation > 90 && absRotation < 270) {
          console.info('Y SCALE')
          newHold.ymin = ycenter - newHalfHeight
          newHold.ymax = ycenter + newHalfHeight
        } else {
          console.info('X SCALE')
          newHold.xmin = xcenter - newHalfWidth
          newHold.xmax = xcenter + newHalfWidth
        }
        this.setState({
          newHold: newHold,
        })
      } else if (gesture.additionalEvent === 'pinchin') {
        let newHalfWidth = halfWidth * 0.99
        let newHalfHeight = halfHeight * 0.99
        //we will only set either the horizontal or vertical component based on the angle of pinch
        let absRotation = Math.abs(gesture.rotation)
        if (absRotation > 90 && absRotation < 270) {
          console.info('Y SCALE')
          newHold.ymin = ycenter - newHalfHeight
          newHold.ymax = ycenter + newHalfHeight
        } else {
          console.info('X SCALE')
          newHold.xmin = xcenter - newHalfWidth
          newHold.xmax = xcenter + newHalfWidth
        }
        this.setState({
          newHold: newHold,
        })
      } else {
        console.info('UNRECOGNIZED PINCH')
      }
    }
  }

  handleSaveNewHold = () => {
    let newHold = Object.assign({}, this.state.newHold)
    newHold.selected = false
    let newHolds = Object.assign([], this.state.holds)
    // it might replace an old hold
    if (newHold.hasOwnProperty('index')) {
      let index = newHold.index
      delete newHold.index
      newHolds[index] = newHold
    } else {
      newHolds = newHolds.concat(newHold)
    }
    this.setState({
      holds: newHolds,
      isAddingHold: false,
      newHold: undefined,
    })
  }

  handleFinishEditing = () => {
    let holdsForFile = this.state.holds.map(hold => {
      return {
        name: 'climbing hold',
        pose: 'Unspecified',
        truncated: '0',
        difficult: '0',
        bndbox: {
          xmin: hold.xmin,
          ymin: hold.ymin,
          xmax: hold.xmax,
          ymax: hold.ymax,
        },
      }
    })
    let fullHoldsFormat = {
      annotation: {
        object: holdsForFile,
      },
    }
    let s = JSON.stringify(fullHoldsFormat)
    let storageRef = window.firebaseStorage.ref()
    let wallId = this.state.wallId
    let wallDir = UrlHelpers.getWallDir(this.state.gym.key, wallId)
    let wallHoldsRef = storageRef.child(wallDir + '/holds.json')
    wallHoldsRef.putString(s).then(snapshot => {
      console.log('Uploaded newWallHoldsFile!')
      this.setState({redirect: true})
    })
  }

  handleCancelEditing = e => {
    this.setState({redirect: true})
  }

  render() {
    // TODO: come up with better key for holds
    let wallUrl = (this.state.wall && this.state.wall.wallUrl) || undefined
    let scale = this.state.scale
    let scaledHeight =
      (this.state.imageHeight && this.state.imageHeight * scale) || '100%'
    let holds = this.state.activeProblem
      ? this.state.activeProblem.holds
      : this.state.holds
    let loading = this.state.loading
    let isAddingHold = this.state.isAddingHold
    let activeHold = true
    let clientWidth = this.state.clientWidth
    let clientHeight = this.state.clientHeight
    let imageWidth = this.state.imageWidth
    let imageHeight = this.state.imageHeight

    if (loading) {
      return (
        <div className="container">
          <Loading />
        </div>
      )
    }
    if (this.state.redirect) {
      return (
        <Redirect
          to={UrlHelpers.wallPath(this.state.gymId, this.state.wallId)}
        />
      )
    }
    let newHold = this.state.newHold

    return (
      <div
        className="container"
        ref={ref => {
          this.containerRef = ref
        }}>
        <Header>
          <UserOrLogin />
        </Header>
        {wallUrl && (
          <DisplayWall
            wallUrl={wallUrl}
            holds={isAddingHold ? [newHold] : holds}
            setImageRef={this.setImageRef}
            scaledHeight={scaledHeight}
            scale={scale}
            handleHoldClick={this.handleHoldClick}
            unselectedStrokeOpacity={0.5}
            selectedFillOpacity={0.4}
            unselectedFillOpacity={0.0}
            isAddingHold={isAddingHold}
            isEditing={true}
            updateNewHold={this.updateNewHold}
            clientWidth={clientWidth}
            clientHeight={clientHeight}
            imageWidth={imageWidth}
            imageHeight={imageHeight}
            addHold={this.handleAddHoldClick}
          />
        )}
        <div className="floating-bottom-right-button">
          {!isAddingHold && (
            <LaddaButton
              onClick={this.handleAddHoldClick}
              data-color="mint"
              data-style={SLIDE_UP}
              data-spinner-color="#ddd"
              className={'round-button'}>
              +
            </LaddaButton>
          )}
          {!isAddingHold && activeHold && (
            <LaddaButton
              onClick={this.handleRemoveHoldClick}
              data-color="red"
              data-style={SLIDE_UP}
              data-spinner-color="#ddd"
              className={'round-button'}>
              -
            </LaddaButton>
          )}
          {!isAddingHold && activeHold && (
            <LaddaButton
              onClick={this.handleFinishEditing}
              data-color="mint"
              data-style={SLIDE_UP}
              data-spinner-color="#ddd"
              className={'round-button'}>
              Finish
            </LaddaButton>
          )}
          {!isAddingHold && activeHold && (
            <LaddaButton
              onClick={this.handleCancelEditing}
              data-color="red"
              data-style={SLIDE_UP}
              data-spinner-color="#ddd"
              className={'round-button'}>
              Cancel
            </LaddaButton>
          )}

          {isAddingHold && (
            <LaddaButton
              onClick={this.handleSaveNewHold}
              data-color="mint"
              data-style={SLIDE_UP}
              data-spinner-color="#ddd"
              className={'round-button'}>
              Save
            </LaddaButton>
          )}
          {isAddingHold && (
            <LaddaButton
              onClick={this.handleCancelAddHoldClick}
              data-color="red"
              data-style={SLIDE_UP}
              data-spinner-color="#ddd"
              className={'round-button'}>
              Cancel
            </LaddaButton>
          )}
        </div>
      </div>
    )
  }
}

export default EditWall



// WEBPACK FOOTER //
// ./src/components/walls/EditWall.jsx